import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseDataService, BaseTabsContainer, BaseTabsUpdateComponent, DefaultListTabsComponent, ModalService, ModalSize, ModelData, QueryParameter, TabsContainerService, UserService } from 'yt-ng-framework';
import { Komitent } from './komitent'
import { ActivatedRoute } from '@angular/router';
import { KomitentUpdateFromNbsComponent } from './komitent-update-from-nbs/komitent-update-from-nbs.component';
import { KomitentView } from './komitent-view';
//import { forEach } from '@angular/router/src/utils/collection';
import { KomitentZrcView } from './komitent-zrc/komitent-zrc-view';

@Component({
  selector: 'yt-komitent-tabs',
  templateUrl: './komitent-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class KomitentTabsComponent extends BaseTabsContainer<KomitentView> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<KomitentView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected modalService: ModalService,
    protected baseDataService: BaseDataService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }


  dodajNovi: string = '0';
  // @ViewChild("baseTabsUpdate", { static: true }) baseTabsUpdate: BaseTabsUpdateComponent<Komitent>;
  @ViewChild("defaulList", { static: false }) defaultList: DefaultListTabsComponent<Komitent>;


  

    UpdateKomitentPoPib(){
      let _modelData = new ModelData(null);
      _modelData.ModalSize = ModalSize.Lg;
      _modelData.UpdateComponent = KomitentUpdateFromNbsComponent;
  
      // let pib: string = this.baseUpdateComponent.baseFormGroup.get("Pib").value;
      // let pibParameter = new QueryParameter("Pib", pib);
      // let id: string = this.baseUpdateComponent.baseFormGroup.get("ID").value;
      // let idParameter = new QueryParameter("ID", id);
  
      if (_modelData) {
        this.modalService
          .ShowModal(0, _modelData, null, true, [

          ])
          .result.then(
            (item) => {
              //alert("Modal success at:")
              //this.baseUpdateComponent['detailList'].RefreshData();
            },
            (reason) => {
              // this.defaultList.LoadMainItems(true);
              //this.baseTabsUpdate.
            }
          );
      }
    }

}

